<template>
    <div
        :class="[
            'component',
            'component__image',
            fullHeight ? 'component__image--fullheight' : '',
            clickable ? 'component__image--clickable' : ''
        ]"
        @click="emitClick"
    >
        <img
            :src="outputUrl"
            :alt="alt"
            :style="height ? `height: ${height}px` : ''"
            onerror="this.style.display='none'"
        >
    </div>
</template>

<script>

import { TokenHelper } from '@/TokenHelper'
import api from '@/api'

export default {
  name: 'component-image',
  props: {
    id: {
      type: String
    },
    url: {
      type: String
    },
    alt: {
      type: String
    },
    size: {
      // one of: original, medium, small
      type: String,
      default: 'medium'
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number
    }
  },
  computed: {
    secondStageToken () {
      return TokenHelper.getToken('secondStageToken')
    },
    outputUrl () {
      return (this.id ? `${api.files}/file/${this.id}` : this.url) + (this.size ? `/${this.size}` : '')
    }
  },
  methods: {
    emitClick () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentimage";
</style>
